<!-- Loading State -->
<div class="loading-container" *ngIf="isLoading && !isTranslationLoaded">
  <qai-loading size="medium"></qai-loading>
</div>
<div class="certification-tab" *ngIf="!isLoading && isTranslationLoaded">
  <div class="header-wrapper">
    <div class="header-section">
      <p>{{ "reportingV2.RESULTS_DESCRIPTION" | transloco }}</p>
      <div class="assignment-selector">
        <app-assignment-filter [assignmentType]="'certification'" (assignmentTypeChange)="onAssignmentChange($event)"></app-assignment-filter>
      </div>
    </div>

    <div
      *ngIf="
        !isLoading &&
        !isNetworkCallInprogress &&
        certificationStats.length === 0
      "
      class="empty-container"
    >
      <p>{{ "reportingV2.NO_ASSIGNMENTS_MATCH_FILTERS" | transloco }}</p>
    </div>

    <!--******************** COMMENTED FOR NOW, WILL BE USED IN FUTURE ************-->

    <!-- <div class="benchmarks-section">
      <qai-reporting-card [title]="('reportingV2.USER_CERTIFIED' | transloco)" [value]="'56%'"></qai-reporting-card>

      <qai-reporting-card [title]="('reportingV2.ASSIGNMENT_CERTIFICATION' | transloco)"
        [value]="'0/3'"></qai-reporting-card>
      <qai-reporting-card [title]="('reportingV2.TRAINER_TIME_SAVED' | transloco)"
        [value]="'132 ' + ('reportingV2.HOURS_LABEL' | transloco)"
        [tooltip]="{icon: 'help-circle', content: ('reportingV2.TRAINER_TIME_SAVED_TOOLTIP' | transloco)}"></qai-reporting-card>
    </div> -->
  </div>

  <div class="loading-container" *ngIf="isNetworkCallInprogress">
    <qai-loading size="medium"></qai-loading>
  </div>

  <ng-container *ngIf="certificationStats.length !== 0 && !isNetworkCallInprogress">
    <app-certification-chart [certificationStats]="visibleCertificationStats"></app-certification-chart>
    
    <app-certification-table [certificationStats]="certificationStats"
      (visibleStatsChanged)="onVisibleStatsChanged($event)"></app-certification-table>
  </ng-container>
</div>
